<template>
  <div>
    <Breadcrumb mainTitle="Sign Up" breadContent="Placeholder" subTitle="Sign Up" />

    <div class="container mt-12 mb-12">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
              <div class="bg-gradient-success shadow-success border-radius-lg py-3 pe-1">
                <h4 class="text-white font-weight-bolder text-center mt-2 mb-0">
                  Sign up
                </h4>
                <div class="row mt-3">
                  <div class="col-2 text-center ms-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-facebook-f text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center px-1">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-github text-white text-lg"></i>
                    </a>
                  </div>
                  <div class="col-2 text-center me-auto">
                    <a class="btn btn-link px-3" href="javascript:;">
                      <i class="fab fa-google text-white text-lg"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <form @submit.prevent="handleSignUp" role="form" class="text-start">
                <MaterialInput id="firstName" v-model="firstName" class="input-group-outline my-3"
                  placeholder="First Name" type="text" />
                <MaterialInput id="lastName" v-model="lastName" class="input-group-outline my-3" placeholder="Last Name"
                  type="text" />
                <MaterialInput id="email" v-model="email" class="input-group-outline my-3" placeholder="Email"
                  type="email" />
                <MaterialInput id="password" v-model="password" class="input-group-outline mb-3" placeholder="Password"
                  type="password" />
                <MaterialInput id="confirmPassword" v-model="confirmPassword" class="input-group-outline mb-3"
                  placeholder="Confirm Password" type="password" />
                <MaterialSwitch v-model="termsAccepted" class="d-flex align-items-center mb-3" id="terms"
                  labelClass="mb-0 ms-3">
                  I agree to the Terms and Conditions
                </MaterialSwitch>

                <div class="text-center">
                  <MaterialButton @click="handleSignUp" class="my-4 mb-2" variant="gradient" color="success" fullWidth>
                    Sign up
                  </MaterialButton>
                </div>
                <p v-if="errorMessage" class="text-danger text-center">{{ errorMessage }}</p>
                <!-- Display error message -->
                <p v-if="successMessage" class="text-success text-center">{{ successMessage }}</p>
                <!-- Display success message -->
                <p class="mt-4 text-sm text-center">
                  Already have an account?
                  <router-link to="/sign-in" class="text-success text-gradient font-weight-bold">
                    Sign In
                  </router-link>
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css';

export default {
  name: 'SignUp',
  components: {
    Breadcrumb,
    MaterialInput,
    MaterialSwitch,
    MaterialButton,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: '',
      termsAccepted: false,
      errorMessage: '',
      successMessage: ''
    };
  },
  methods: {
    async handleSignUp() {
      // Basic form validation
      if (!this.termsAccepted) {
        this.errorMessage = 'You must accept the terms and conditions.';
        return;
      }

      if (this.password !== this.confirmPassword) {
        this.errorMessage = 'Passwords do not match.';
        return;
      }

      try {
        // Make a POST request to the backend /register endpoint
        const response = await axios.post('http://172.96.161.120:7675/register', {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          password: this.password
        });

        // Handle successful registration
        this.successMessage = 'Registration successful!';
        // You may want to redirect the user to the sign-in page
        this.$router.push('/sign-in');
      } catch (error) {
        // Handle errors
        this.errorMessage = error.response?.data?.message || 'An error occurred during registration.';
      }
    }
  },
  async mounted() {
    // Scrolling to top of the window
    window.scrollTo(0, 0);
  },
};
</script>